import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { IconBell } from '@tabler/icons-react';
import { ScreenNotificationPanel } from './ScreenNotificationPanel';
import { ScreenNotification } from '../hooks/useScreenNotifications';

interface ScreenNotificationButtonProps {
  notifications: ScreenNotification[];
  unreadCount: number;
  onDismiss: (id: string) => void;
  onClearAll: () => void;
  onMarkAllAsRead: () => void;
}

export const ScreenNotificationButton: React.FC<ScreenNotificationButtonProps> = ({
  notifications,
  unreadCount,
  onDismiss,
  onClearAll,
  onMarkAllAsRead,
}) => {
  const [show, setShow] = useState(false);

  const handleToggle = (nextShow: boolean) => {
    setShow(nextShow);

    // Keď sa dropdown zatvorí, vymaž všetky notifikácie
    if (!nextShow && notifications.length > 0) {
      onClearAll();
    }
  };

  return (
    <Dropdown show={show} onToggle={handleToggle}>
      <Dropdown.Toggle
        as="button"
        className="btn btn-warning position-relative"
        style={{ padding: '0.375rem 0.75rem' }}
        bsPrefix="btn"
      >
        <IconBell size={20} />
        {unreadCount > 0 && (
          <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            style={{ fontSize: '0.65rem', padding: '0.2em 0.4em', color: 'white' }}
          >
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </Dropdown.Toggle>

      <ScreenNotificationPanel
        notifications={notifications}
        onDismiss={onDismiss}
        onClearAll={onClearAll}
        onMarkAllAsRead={onMarkAllAsRead}
      />
    </Dropdown>
  );
};
